import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
} from "@mui/material";
import { CheckCircle, Clear } from "@mui/icons-material";

export default function ShippingTypeCard({ order }) {
    const { t } = useTranslation();
    return (
        <Card>
            <CardHeader title={t("Shipping type")} />
            <Divider />
            <CardContent sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{mr: 3}}>{t("Express shipping")}</Typography>
                {
                    order?.quickShipping ?
                    <CheckCircle color="success" />
                    :
                    <Clear color="error" />
                }
            </CardContent>
        </Card>
    );
};

